export default __webpack_public_path__ + "assets/74ff1edc82ca9248d61c79ae5ebc5ac7.png";